import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  VERIFY_USER_IDENTITY_FEATURE_KEY,
  VerifyUserIdentityState,
} from './verify-user-identity.reducer';

// Lookup the 'VerifyUserIdentity' feature state managed by NgRx
export const selectVerifyUserIdentityState =
  createFeatureSelector<VerifyUserIdentityState>(
    VERIFY_USER_IDENTITY_FEATURE_KEY,
  );

export const selectVerifyUserIdentityLoaded = createSelector(
  selectVerifyUserIdentityState,
  (state: VerifyUserIdentityState) => state.loaded,
);

export const selectVerifyUserIdentityLoading = createSelector(
  selectVerifyUserIdentityState,
  (state: VerifyUserIdentityState) => state.loading,
);

export const selectVerifyUserIdentityError = createSelector(
  selectVerifyUserIdentityState,
  (state: VerifyUserIdentityState) => state.error,
);

export const selectVerifyUserIdentityAction = createSelector(
  selectVerifyUserIdentityState,
  (state: VerifyUserIdentityState) => state.action,
);
export const selectLastVerifyUserIdentity = createSelector(
  selectVerifyUserIdentityState,
  (state: VerifyUserIdentityState) => ({
    identityVerifiedAt: state.identityVerifiedAt,
    identityVerified: state.identityVerified,
  }),
);
